import { Feed, getPersonFullName } from '@mntn-dev/ui-components'
import { ActivityTrans } from '../activity-trans.tsx'
import { Link } from '../index.ts'
import type { ActivityDetailsProps } from './types.ts'

export const ServiceNoteAdded = ({
  activity: {
    person,
    details: {
      activityType,
      data: { project, service, noteType },
    },
  },
  t,
  onNavigate,
  currentUrl,
}: ActivityDetailsProps<'service_note_added'>) =>
  person && (
    <>
      <Feed.Summary>
        <ActivityTrans
          t={t}
          i18nKey={`${activityType}.summary`}
          values={{
            subject: getPersonFullName(person),
            serviceName: service.name,
            noteType,
          }}
        />
      </Feed.Summary>
      <Feed.Annotations>
        <Link {...{ target: project, t, onNavigate, currentUrl }} />
      </Feed.Annotations>
    </>
  )
